import { render, staticRenderFns } from "./lrTable.vue?vue&type=template&id=74714a6b"
import script from "./lrTable.vue?vue&type=script&lang=js"
export * from "./lrTable.vue?vue&type=script&lang=js"
import style0 from "./lrTable.vue?vue&type=style&index=0&id=74714a6b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports